import type { CSSProperties } from 'react';

import { useWalletContext } from '#src/contexts/wallet/index.ts';
import { useEffectOnChange } from '#src/hooks/state/useEffectOnChange.ts';

interface Props {
  className?: string;
  withoutHeader?: boolean;
  style?: CSSProperties;
}

export const Placeholder = ({ className, style, withoutHeader }: Props) => {
  const { walletNode, setWalletNode } = useWalletContext();
  const notifyStyleChanged = () => {
    if (walletNode) {
      walletNode.dispatchEvent(new Event('styleChanged', { bubbles: false }));
    }
  };
  useEffectOnChange(style, () => {
    notifyStyleChanged();
  });

  const effectiveStyle = !withoutHeader
    ? style
    : { ...style, '--header-size': 0 };

  return (
    <div ref={setWalletNode} className={className} style={effectiveStyle} />
  );
};
